import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';

import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environment/environment';
import { UserGroupDTO } from '../../../dto/user-group/user-group.dto';
import { UserGroupMemberDTO } from '../../../dto/user-group/user-group-member.dto';

export interface DunaUserGroupsViewMembersDialogData {
  group: UserGroupDTO;
  locationGuid?: string | null;
}

export const DUNA_USER_GROUPS_VIEW_MEMBERS_DIALOG_CONFIG = {
  width: '90vw',
  minWidth: '900px',
  maxWidth: '1200px',
  maxHeight: '90vh',
};

@Component({
  selector: 'app-duna-user-groups-view-members-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatProgressSpinnerModule,
    RouterModule,
  ],
  template: `
    <h2 mat-dialog-title>Brugere i {{ data.group.name }}</h2>
    <mat-dialog-content>
      @if (loading) {
      <p class="loading">
        <mat-progress-spinner
          diameter="24"
          mode="indeterminate"
        ></mat-progress-spinner>
        Henter…
      </p>
      } @if (!loading && members.length) {
      <mat-list>
        @for (m of members; track m) {
        <mat-list-item>
          <mat-icon matListItemIcon>person</mat-icon>
          <span matListItemTitle>{{ m.name }}</span>
          <a mat-button color="primary" [routerLink]="['/profile', m.uuid]"
            >Profil</a
          >
        </mat-list-item>
        }
      </mat-list>
      } @if (!loading && !members.length) {
      <p class="empty">Ingen brugere i denne gruppering.</p>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button (click)="dialogRef.close()">Luk</button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      mat-dialog-content {
        min-width: 860px;
        width: 100%;
        max-height: 70vh;
        box-sizing: border-box;
      }
      mat-list-item {
        height: auto !important;
        min-height: 48px;
      }
      .loading {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .empty {
        color: #888;
        font-style: italic;
      }
    `,
  ],
})
export class DunaUserGroupsViewMembersDialogComponent implements OnInit {
  loading = true;
  members: UserGroupMemberDTO[] = [];

  constructor(
    public dialogRef: MatDialogRef<DunaUserGroupsViewMembersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DunaUserGroupsViewMembersDialogData,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    const id = this.data.group.group_id;
    const url = this.data.locationGuid
      ? `${environment.apiUrl}/user-groups/${id}/members/by-location/${this.data.locationGuid}`
      : `${environment.apiUrl}/user-groups/${id}/members`;
    this.http.get<any>(url).subscribe({
      next: (res) => {
        const payload = res?.data ?? res;
        this.members = payload.members || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }
}
